<template>
  <div class="salerFixedTips">
    <div class="salerFixedTips-bg">
      <div v-if="visibleOne" class="salerFixedTips-box">
        <p>开始带看啦，打招呼同时可以先看看客户标签哦</p>
        <span
          v-stat:click="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_1_click',
            extend: {
              channelId,
            },
          }"
          v-stat:show="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_1_show',
            extend: {
              channelId,
            },
          }"
          class="salerFixedTips-btn"
          @click="runModal(1)"
        >
          看标签
        </span>
      </div>
      <div v-if="visibleTwo" class="salerFixedTips-box">
        <p>转动展厅为客户讲解一下吧～</p>
      </div>
      <div v-if="visibleThree && hasRedPacket" class="salerFixedTips-box">
        <p>店里的红包发一发，更能促进客户进店</p>
        <span
          v-stat:click="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_2_click',
            extend: {
              channelId,
            },
          }"
          v-stat:show="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_2_show',
            extend: {
              channelId,
            },
          }"
          class="salerFixedTips-btn"
          @click="runModal(3)"
        >
          去发红包
        </span>
      </div>
      <div v-if="visibleThree && !hasRedPacket" class="salerFixedTips-box">
        <p>邀请客户进店试驾，您将成为客户的专属顾问</p>
        <span
          v-stat:click="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_3_click',
            extend: {
              channelId,
            },
          }"
          v-stat:show="{
            action: 'dlr_vr_tonghauzhong_b_yindaobiaoqian_3_show',
            extend: {
              channelId,
            },
          }"
          class="salerFixedTips-btn"
          @click="runModal(4)"
        >
          去预约
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
const timerOne = 5;
const timers = 10;
export default {
  data () {
    return {
      visibleOne: true,
      visibleTwo: false,
      visibleThree: false
    };
  },
  computed: {
    ...mapGetters('redPacket', { hasRedPacket: 'hasRedPacket' }),
    ...mapGetters({
      vrSalesInfo: 'sales/vrSalesInfo'
    }),
    channelId () {
      return this.vrSalesInfo.channelId;
    },
  },
  created () {
    this.$bus.$on('called', () => {
      this.showOne();
      this.showTwo();
    });
  },
  methods: {
    runModal (index) {
      this.$bus.$emit('showTestPop', index);
    },
    showOne() {
      setTimeout(() => {
        this.visibleOne = false;
        this.visibleTwo = true;
      }, timerOne * 1000);
    },
    showTwo() {
      setTimeout(() => {
        this.visibleThree = true;
        this.visibleOne = false;
        this.visibleTwo = false;
      }, timers * 1000);
    }
  },
};
</script>
